import { Box, Modal } from '@mui/material';
import React from 'react';

import { BasicModalProps } from './BasicModal.types';

const style = {
  position: 'absolute',
  top: '10%',
  left: '50%',
  transform: 'translate(-50%,0)',
  maxWidth: '100%',
  maxHeight: '100%',
  bgcolor: 'background.paper',
  //   border: '2px solid #000',
  borderRadius: '10px',
  boxShadow: 24,
  overflow: 'auto',
  // p: 4,
};
export default function BasicModal({
  open,
  onClose = () => {},
  children,
  ...rest
}: BasicModalProps) {
  return (
    <Modal open={open} onClose={onClose} {...rest}>
      <Box sx={style}>{children}</Box>
    </Modal>
  );
}
